module.exports = __webpack_public_path__ + "static/media/Mobile Pumping Unit Services.e626af12.png";